import React from 'react';
import { TelegramAuthData } from '@telegram-auth/react';

// 共享的类型定义
//登录检查
export interface CheckLoginResponse {
  is_login: boolean;
}
// 认证上下文类型
export interface AuthContextType {
  user: User | null;
  loading: boolean;
  login: (email: string, password: string) => Promise<void>;
  register: (
    email: string,
    password: string,
    email_code?: string,
    invite_code?: string,
    recaptcha_data?: string,
    telegram_id?: number,
    init_data?: string
  ) => Promise<void>;
  checkLogin: () => Promise<boolean>;
  telegramLogin: (telegramUser: any, initData: string) => Promise<void>;
  telegramWidgetLogin: (telegramUser: TelegramAuthData) => Promise<void>;
  logout: () => void;
  updateUser: (userData: Partial<User>) => void;
}

export interface AuthProviderProps {
  children: React.ReactNode;
}

// 用户相关类型
export interface User {
  email: string;
  transfer_enable: number;
  last_login_at: number;
  created_at: number;
  banned: number;
  remind_expire: number;
  remind_traffic: number;
  expired_at: number;
  balance: number;
  commission_balance: number;
  plan_id: number;
  discount: number;
  commission_rate: number;
  telegram_id: number;
  uuid: string;
  avatar_url: string;
  token: string; //后端不返回
}

// 套餐相关类型
export interface Plan {
  id: number;
  group_id: number;
  transfer_enable: number;
  name: string;
  speed_limit: number;
  show: number;
  sort: number;
  renew: number;
  content: string;
  month_price: number;
  quarter_price: number;
  half_year_price: number;
  year_price: number;
  two_year_price: number;
  three_year_price: number;
  onetime_price: number;
  reset_price: number;
  reset_traffic_method: number;
  capacity_limit: number;
  created_at: number;
  updated_at: number;
}





// 套餐周期类型
export type PeriodType = 'month_price' | 'quarter_price' | 'half_year_price' | 'year_price' | 'two_year_price' | 'three_year_price' | 'onetime_price' | 'reset_price';

// 套餐周期标签
export const periodLabels: Record<PeriodType, string> = {
  month_price: '月付',
  quarter_price: '季付',
  half_year_price: '半年付',
  year_price: '年付',
  two_year_price: '两年付',
  three_year_price: '三年付',
  onetime_price: '一次性',
  reset_price: '重置包',
};

// 订阅信息类型
export interface SubscriptionInfo {
  plan_id: number;
  token: string;
  expired_at: number;
  u: number;
  d: number;
  transfer_enable: number;
  email: string;
  uuid: string;
  plan: Plan;
  subscribe_url: string;
  reset_day?: number;
}

// 节点信息类型

export interface NodeInfo {
  id: number;
  group_id: string[];
  route_id: string[];
  parent_id: number;
  tags: string[];
  name: string;
  rate: string;
  host: string;
  port: number;
  server_port: number;
  cipher: string;
  obfs: string;
  obfs_settings: string;
  show: number;
  sort: number;
  created_at: number;
  updated_at: number;
  type: string;
  last_check_at: string;
  is_online: number;
  cache_key: string;
}
//KnowledgeItem
export interface KnowledgeItem {
  id: number;
  category: string;
  title: string;
  updated_at: number;
}

export interface KnowledgeList {
  id: number;
  category: string;
  title: string;
  updated_at: number;
}
/**
 *  {
                "id": 199,
                "user_id": 24643,
                "ticket_id": 86,
                "message": "\u4f60\u597d",
                "created_at": 1749997619,
                "updated_at": 1749997619,
                "is_me": true
            }
 */
export interface TicketItem {
  id: number;
  user_id: number;
  ticket_id: number;
  message: string;
  created_at: number;
  updated_at: number;
  is_me: boolean;
}
//邀请列表
export interface InviteItem {
  id: number;
  trade_no: string;
  order_amount: number;
  get_amount: number;
  created_at: number;
  updated_at: number;
}
//邀请码
export interface InviteCode {
  id: number;
  user_id: number;
  code: string;
  status: number;
  pv: number;
  created_at: number;
  updated_at: number;
}
//邀请码列表及邀请概况
export interface InviteCodeListState {
  codes: InviteCode[];
  stat: Number[];
}

//UserConfig
export interface UserConfig {
  is_telegram: Number;
  telegram_discuss_link: string;
  stripe_pk: string;
  withdraw_methods: string[];
  withdraw_close: Number;
  currency: string;
  currency_symbol: string;
  commission_distribution_enable: Number;
  commission_distribution_l1: Number;
  commission_distribution_l2: Number;
  commission_distribution_l3: Number;
}


// 导出订单相关类型
export * from './order';
